import React, { FC, ReactElement } from 'react';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import IconButton from 'src/components/atoms/buttons/IconButton';
import SurveyButton from 'src/components/atoms/buttons/SurveyButton';
import './style.scss';

interface Props {
  removeLabel?: string;
  addClickEvt?: () => void;
  modifyClickEvt?: () => void;
  viewType?: string;
  queClickEvt?: () => void;
  queLabel?: string;
}
const TaxTopButton: FC<Props> = ({
  addClickEvt,
  modifyClickEvt,
  viewType,
  queClickEvt,
  queLabel = '',
}) => {
  const refleshEvt = () => {};

  const modifyEvt = () => {
    if (modifyClickEvt) modifyClickEvt();
  };
  const confirmEvt = () => {
    if (addClickEvt) addClickEvt();
  };
  let modifyIIcon = 'ri-edit-fill';
  if (viewType === 'modify') modifyIIcon = 'ri-arrow-go-back-line';

  return (
    <div className="_tax_top_btn_div">
      <div className="_left">
        {queClickEvt ? <SurveyButton clickEvent={e => queClickEvt()} queLabel={queLabel} /> : ''}
        {/* queClickEvt */}
        {/* <div className="_btn">
          <DefaultButton
            text="다시 불러오기"
            clickEvent={e => refleshEvt()}
            icon="ri-reset-left-fill"
            type="type1"
            styleDef={{ height: '30px', fontSize: '13px', width: '130px' }}
          />
        </div> */}
        {/* <div className="_btn">
          <DefaultButton
            text="다시 불러오기"
            clickEvent={e => refleshEvt()}
            icon="ri-reset-left-fill"
            type="type1"
            styleDef={{ height: '30px', fontSize: '13px', width: '130px' }}
          />
        </div> */}
      </div>
      <div className="_right">
        {/* <div className="_btn _right">
          <IconButton
            clickEvent={e => refleshEvt()}
            icon="ri-reset-left-fill"
            type="type3"
            styleDef={{ height: '30px', width: '30px', fontSize: '14px' }}
          />
        </div> */}
        <div className="_btn _right">
          <IconButton
            clickEvent={e => modifyEvt()}
            icon={modifyIIcon}
            type="type3"
            styleDef={{ height: '30px', width: '30px', fontSize: '14px' }}
          />
        </div>
        <div className="_btn _right">
          <DefaultButton
            text="추가"
            clickEvent={e => confirmEvt()}
            icon="ri-sticky-note-add-line"
            type="type4"
            styleDef={{ height: '30px', fontSize: '13px', width: '80px' }}
          />
        </div>
      </div>
    </div>
  );
};

export default TaxTopButton;
